import profileStoreMutations from '@/state/profileStore/profileStoreMutations'
import profileStoreActions from '@/state/profileStore/profileStoreActions'
import getProfileStoreDefaultState from '@/state/profileStore/profileStoreDefaultState'

let state = getProfileStoreDefaultState()

export const profileStore = {
  namespaced: true,
  state,
  getters: {
    user: state => state.user,
    isTeamOwner: state => {
      return Object.keys(state.user).length
        ? state.user.roles.includes('team_owner') ||
            state.user.roles.includes('store_admin')
        : false
    }
  },
  mutations: profileStoreMutations,
  actions: profileStoreActions
}
